<template>
  <UserLayout
    :showNavBar="false"
    :hideCompanyInfo="hideCompanyInfo"
    pageTitle="Dashboard"
  >
    <template #page-content="props">
      <v-row>
        <!-- <v-col cols="6" md="4" lg="3">
          <v-btn class="btn-counter" color="eporange  white--text">
            <v-row>
              <v-col sm="3">
                <v-icon class="counter-icon">mdi-toolbox </v-icon>
              </v-col>

              <v-col sm="9" class="text-right">
                <span class="counter-description">Attrezzature</span>
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                <span class="percentage-counter-value">20%</span>
              </v-col>
              <v-col cols="12">
                <v-progress-linear value="20" color="white"></v-progress-linear>
              </v-col>
            </v-row>
          </v-btn>
        </v-col> -->
        <v-col cols="6" md="4" lg="3">
          <v-btn
            class="btn-counter"
            color="eporange  white--text"
            @click="goToAttr"
          >
            <v-row>
              <v-col sm="3" class="d-none d-sm-flex">
                <v-icon class="counter-icon">mdi-toolbox</v-icon>
              </v-col>

              <v-col sm="9" cols="12" class="text-right">
                <span class="counter-description">Attrezzature</span>
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                <span class="percentage-counter-value">{{
                  counters.equipments
                }}</span>
              </v-col>
              <v-col cols="12">
                <!--<v-progress-linear value="2" color="white"></v-progress-linear>-->
              </v-col>
            </v-row>
          </v-btn>
        </v-col>
        <v-col cols="6" md="4" lg="3">
          <v-btn
            class="btn-counter"
            color="epgreen  white--text"
            @click="goToMezzi"
          >
            <v-row>
              <v-col sm="3" class="d-none d-sm-flex">
                <v-icon class="counter-icon">mdi-truck</v-icon>
              </v-col>

              <v-col sm="9" cols="12" class="text-right">
                <span class="counter-description">Mezzi</span>
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                <span class="percentage-counter-value">{{
                  counters.vehicles
                }}</span>
              </v-col>
              <v-col cols="12">
                <!-- <v-progress-linear value="20" color="white"></v-progress-linear> -->
              </v-col>
            </v-row>
          </v-btn>
        </v-col>
        <v-col cols="6" md="4" lg="3">
          <v-btn
            class="btn-counter"
            color="epblue white--text"
            @click="goToOper"
          >
            <v-row>
              <v-col sm="3" class="d-none d-sm-flex">
                <v-icon class="counter-icon">mdi-account-hard-hat </v-icon>
              </v-col>

              <v-col sm="9" class="text-right">
                <span class="counter-description">Operatori</span>
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                <span class="percentage-counter-value">{{
                  counters.operators
                }}</span>
              </v-col>
              <v-col cols="12">
                <!-- <v-progress-linear value="20" color="white"></v-progress-linear> -->
              </v-col>
            </v-row>
          </v-btn>
        </v-col>
        <v-col cols="6" md="4" lg="3">
          <v-btn
            class="btn-counter"
            color="epred darken-2 white--text"
            @click="goToUsers"
          >
            <v-row>
              <v-col sm="3" class="d-none d-sm-flex">
                <v-icon class="counter-icon">mdi-account </v-icon>
              </v-col>

              <v-col sm="9" class="text-right">
                <span class="counter-description">Utenti</span>
                <v-spacer></v-spacer>
                <v-divider></v-divider>
                <span class="percentage-counter-value">{{
                  counters.users
                }}</span>
              </v-col>
              <v-col cols="12">
                <!-- <v-progress-linear value="20" color="white"></v-progress-linear> -->
              </v-col>
            </v-row>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-row>
            <v-col sm="4">
              <h3 class="widget-title black--text">Agenda personale</h3>

              <v-divider color="red"></v-divider>

              <v-col sm="12" style="height: 100%">
                <v-card
                  class="widget-form"
                  outlined
                  :elevation="10"
                  style="height: 400px; width: 99%"
                >
                  <AgendaViewer
                    :showTitle="Boolean(false)"
                    :show-mobile-version="Boolean(true)"
                  ></AgendaViewer>
                </v-card>
              </v-col>
            </v-col>
            <v-col sm="8" v-if="!plannerViewDisabled">
              <h3 class="widget-title black--text">Riepilogo interventi</h3>

              <v-divider color="red"></v-divider>
              <v-col sm="12">
                <v-card
                  class="widget-form"
                  style="width: 99%"
                  outlined
                  :elevation="10"
                >
                  <FrmPlanner
                    :refreshInterval="10000"
                    ref="planner"
                    :allow-drag-and-drop-events="Boolean(false)"
                    :allow-edit-events="Boolean(true)"
                    :allow-select-cells="Boolean(false)"
                    :showCellHover="Boolean(false)"
                    v-bind:height="400"
                    :full-screen="Boolean(false)"
                    :showToolbar="Boolean(false)"
                    :showOptions="Boolean(false)"
                    :showBackButton="Boolean(false)"
                    :showTitlebar="Boolean(false)"
                    :title="String('Eventi pianificati')"
                  ></FrmPlanner>
                </v-card>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row> </v-row>

      <v-row> </v-row>

      <v-row>
        <div style="height: 100px" class="d-md-none"></div>
      </v-row>
    </template>
  </UserLayout>
</template>

<style lang="scss">
.tiles-group {
  padding-left: 30px;
  padding-right: 30px;
}
.v-card__title.overline {
  line-height: 13px;
  word-break: keep-all;
}
.mainPage[isMobile="true"] {
  padding: 5px 2px;
}
.mainPage {
  background: transparent;
  // height: 100vh;
  width: 100vw;
  display: block;
}
.mainPage:not([isMobile]) .dashboardLink {
  height: 180px;
}

.mainPage[isMobile] .dashboardLink {
  height: 150px;
}

.dashboardLink:hover {
  transform: scale(1.06);
  transition: transform 0.3s;
}

.dashboardLink .v-card__text {
  position: absolute;
  bottom: 0px;
}
.btn-counter.v-btn {
  display: block;
  width: 100%;
  min-height: 110px !important;
  padding: 20px;
}
.agenda-viewer {
  height: 100%;
}
h3.widget-title {
  font-weight: 400;
}
span.counter-description {
  font-weight: 100;
}
span.counter-value {
  font-size: 29px;
  font-weight: 100;
}
span.percentage-counter-value {
  font-size: 30px;
  font-weight: 100;
}
.widget-form {
  border-radius: 0;
}
.cardInfo {
  opacity: 0.8;
  padding: 10px;
  position: fixed;
  bottom: 20px;
  right: 108px;
}
.logo img {
  // display: block;
}
.logo {
  // display: block !important;
  // text-align: center;
  // // justify-content: center !important;
  // // align-content: center !important;
  // width: 100%;
}
i.v-icon.notranslate.counter-icon {
  font-size: 4em;
  font-weight: 100;
}
.cardContent {
  display: grid;
  align-content: center;
  justify-content: center;
}
</style>

<script>
import EasyPlanClient from "../utils/EasyPlanClient";
import UserLayout from "../layout/UserLayout";
import SessionHelper from "../utils/SessionHelper";
import moment from "moment";
import UISettingsHelper from "../utils/UISettingsHelper";
import FrmPlanner from "../components/Planner/FrmPlanner";
import CounterType from "../settings/CounterType";
import AgendaViewer from "../components/CustomComponentsUI/AgendaViewer";
export default {
  props: {
    showNavBar: { type: Boolean, default: false },
    hideCompanyInfo: { type: Boolean, default: true },
  },
  data: () => ({
    moment: moment,
    isMobile: false,
    loadingUISettings: false,
    counters: {
      operators: "---",
      vehicles: "---",
      users: "---",
      equipments: "---",
    },
  }),
  components: {
    CounterType,
    UserLayout,
    FrmPlanner,
    AgendaViewer,
  },
  mounted() {
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
    this.loadCounters();
  },
  created: async function () {
    this.checkIfIsMobile();
    this.loadingUISettings = true;
    await UISettingsHelper.Pull(this.$route.params.companyAlias);
    if (
      localStorage.userToken == undefined ||
      localStorage.userToken == "null"
    ) {
      SessionHelper.Logoff(this.$route.params.companyAlias);
    } else {
      SessionHelper.loadUserInfo(this.$route.params.companyAlias);
      SessionHelper.loadCompanyInfo(this.$route.params.companyAlias);
    }
  },
  methods: {
    goToUsers() {
      this.$router.push(`/${this.$route.params.companyAlias}/Users`);
    },
    goToMezzi() {
      this.$router.push(`/${this.$route.params.companyAlias}/Workers`);
    },
    goToAttr() {
      this.$router.push(`/${this.$route.params.companyAlias}/Workers`);
    },
    goToOper() {
      this.$router.push(`/${this.$route.params.companyAlias}/Workers`);
    },
    loadCounters() {
      this.loadOperatorsCounter((data) => (this.counters.operators = data));
      this.loadUsersCounter((data) => (this.counters.users = data));
      this.loadVehiclesCounter((data) => (this.counters.vehicles = data));
      this.loadEquipmentsCounter((data) => (this.counters.equipments = data));
    },
    loadOperatorsCounter(callback = (d) => {}) {
      EasyPlanClient.Counters.GetCounter(
        this.$route.params.companyAlias,
        CounterType.Operators
      )
        .then((res) => {
          callback(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    loadUsersCounter(callback = (d) => {}) {
      EasyPlanClient.Counters.GetCounter(
        this.$route.params.companyAlias,
        CounterType.Users
      )
        .then((res) => {
          callback(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    loadVehiclesCounter(callback = (d) => {}) {
      EasyPlanClient.Counters.GetCounter(
        this.$route.params.companyAlias,
        CounterType.Vehicles
      )
        .then((res) => {
          callback(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    loadEquipmentsCounter(callback = (d) => {}) {
      EasyPlanClient.Counters.GetCounter(
        this.$route.params.companyAlias,
        CounterType.Equipments
      )
        .then((res) => {
          callback(res.data.data);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    checkIfIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
    Logoff() {
      SessionHelper.Logoff(this.$route.params.companyAlias);
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
  },
  computed: {
    showSidebar() {
      return SessionHelper.checkPermission("SHOW_SIDEBAR");
    },
    plannerViewDisabled() {
      return !(
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("CUSTOMERS_READ")
      );
    },
    UISettings() {
      UISettingsHelper.LoadSettings();
      return UISettingsHelper.GetSettings();
    },

    imgSize() {
      if (this.isMobile) return { height: "70px", width: "65px" };
      else return { height: "100px", width: "90px" };
    },
  },
};
</script>
